import React from 'react';
import { Bot, Sparkles } from 'lucide-react';

const AsistenteIA = () => {
    return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] text-center space-y-6 animate-in fade-in zoom-in duration-700">
            <div className="relative">
                <div className="absolute -inset-1 bg-gradient-to-r from-primary-600 to-purple-600 rounded-full blur opacity-25 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
                <div className="relative bg-white p-8 rounded-full shadow-2xl">
                    <Bot size={80} className="text-primary-600" />
                </div>
                <div className="absolute top-0 right-0">
                    <Sparkles className="text-yellow-400 animate-pulse" size={32} />
                </div>
            </div>
            
            <div className="max-w-md space-y-2">
                <h2 className="text-3xl font-extrabold text-gray-900 tracking-tight">Asistente IA</h2>
                <p className="text-gray-500 text-lg">
                    Estamos preparando una inteligencia artificial avanzada para ayudarte a gestionar tus comunicaciones de forma automática.
                </p>
            </div>

            <div className="flex gap-4">
                <div className="px-4 py-2 bg-gray-100 rounded-full text-sm text-gray-600 font-medium">Próximamente</div>
                <div className="px-4 py-2 bg-primary-50 text-primary-700 rounded-full text-sm font-bold border border-primary-100">En Desarrollo</div>
            </div>
        </div>
    );
};

export default AsistenteIA;
